import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const seoAdminAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.SeoMarketplaceView],
}
